import { HistoryStackEntry } from "../types/HistoryStackEntry";
import { NavigationEventType } from "../types/NavigationEventType";
import { PageEnterDetail } from "../types/PageEnterDetail";

interface ProcessUnknownArgs {
  currentUrl: string;
  emitEvent: (type: NavigationEventType, detail?: PageEnterDetail) => void;
  fscriptId: string;
  HistoryIndexKey: string;
  historyStack: HistoryStackEntry[];
  HistoryStackKey: string;
  fscriptSessionId: string;
}

export const processUnknown = ({
  emitEvent,
  fscriptId: _fscriptId,
  HistoryIndexKey,
  historyStack,
  HistoryStackKey,
  fscriptSessionId,
}: ProcessUnknownArgs) => {
  const fscriptId = _fscriptId || history.state.fscriptId;
  let newCurrentIndex = historyStack.length;

  setTimeout(() => {
    historyStack.push({
      url: location.href,
      fscriptId,
    });

    localStorage.setItem(
      HistoryStackKey + fscriptSessionId,
      JSON.stringify(historyStack)
    );
    localStorage.setItem(
      HistoryIndexKey + fscriptSessionId,
      newCurrentIndex.toString()
    );
  }, 1);

  emitEvent("page_load", "unknown_navigation_type");
};
